import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import root from './reducers/root';
// import { createLogger } from 'redux-logger';

const configureFyhStore = (preloadedState) => {
  const middleware = [];
  middleware.push(thunkMiddleware);
  // const loggerMiddleware = createLogger({
  //   predicate: () => process.env.NODE_ENV === 'development'
  // });
  // middleware.push(loggerMiddleware);

  return createStore(root, preloadedState, applyMiddleware(...middleware));
};

export default configureFyhStore;
